import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from './api-client';
import { keysFactory } from './credit-api';
const downloadVouchedReport = async ({ creditApplicationId, vouchedJobToken, financingProgram, applicantType, }) => {
    return await apiClient.post(`${financingProgram}/creditapplication/${creditApplicationId}/downloadVouchedReport`, {
        vouchedJobToken,
        applicantType,
    });
};
// Only used when vouched failed
export function useDownloadVouchedReport() {
    const queryClient = useQueryClient();
    const { mutateAsync, isPending } = useMutation({
        mutationFn: downloadVouchedReport,
        onSuccess: (_data, variables) => {
            const creditApp = queryClient.getQueryData(keysFactory.detail(variables.creditApplicationId, variables.financingProgram));
            if (creditApp) {
                queryClient.setQueryData(keysFactory.detail(variables.creditApplicationId, variables.financingProgram), {
                    ...creditApp,
                    applicant: {
                        ...creditApp.applicant,
                        vouchedFailedCount: (creditApp?.applicant?.vouchedFailedCount ?? 0) + 1,
                    },
                });
            }
        },
    });
    return [mutateAsync, isPending];
}
